// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Header_breadcrumbs__mCYlG","headerLogo":"Header_headerLogo__qxS_C","headerLogoSmall":"Header_headerLogoSmall__A7Hg_"};